module.exports = __webpack_public_path__ + "static/img/ksa-certification-system.9eb9e5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/ksa-certification-system.jpg
// module id = 3YNW
// module chunks = 0